import React,{useEffect, useState}from 'react'
import Main from '../../cpn/Main'
import { Table} from 'antd';
import {useBnsGuangGaoFaBuListQuery } from '../../store/ReactWebSiteApi';
import PublishCheck from './PublishCheck';
function PublishTask() {       
    const [list, setList] = useState();    
    const {data, isSuccess} = useBnsGuangGaoFaBuListQuery({
        bggfb_fuzhuren_id:localStorage.getItem('eu_id')
    });    
    useEffect(() => {
        if (isSuccess) {
            console.log(data);
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {bggfb_id:key,bggfb_name,bggfb_ctime,bggfb_cname,bggfb_content,bggfb_dept_id,bggfb_dept_name,bggfb_jihuariqi,bggfb_bg_name,bggfb_meijie_name,bggfb_fuzhuren_name,bggfb_state} = item;
                    return item = {key,bggfb_name,bggfb_ctime,bggfb_cname,bggfb_content,bggfb_dept_id,bggfb_dept_name,bggfb_jihuariqi,bggfb_bg_name,bggfb_meijie_name,bggfb_fuzhuren_name,bggfb_state}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.bggfb_ctime;
                    let bTimeString = b.bggfb_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])
    const columns = [
        {
            key: 'bggfb_jihuariqi',
            title: '日期',            
            dataIndex:'bggfb_jihuariqi'
        },
       
        {
            key: 'bggfb_bg_name',
            title: '产品',            
            dataIndex:'bggfb_bg_name'
        },
        {
            key: 'bggfb_meijie_name',
            title: '媒介',            
            dataIndex: 'bggfb_meijie_name',
            
        },
        {
            key: 'bggfb_fuzhuren_name',
            title: '负责人',            
            dataIndex: 'bggfb_fuzhuren_name',
            
        },
        {
            key: 'list',
            title: '名称',
            render:(_,record) => {
                return  <PublishCheck 
                            bggfb_name={record.bggfb_name}
                            bggfb_id={record.key}
                        />
            }            
        },   
        {
            key: 'bggfb_state',
            title: '状态',
            dataIndex:'bggfb_state',
            render:(text) => {
                if(text==='1'){
                    return<>已实现</>
                }else{
                    return<>待实现</>
                }
            }   
        },       
        {
            key: 'num',
            title: '编号',            
            dataIndex: 'key',
            
        },
        {
            key: 'bggfb_dept_name',
            title: '部门',            
            dataIndex: 'bggfb_dept_name',
            
        },
        {
            key: 'time',
            title: '操作记录',
            render: (_,record) => {
                return <>{record.bggfb_ctime + record.bggfb_cname}</>
            }
        },
    ]   
    return (
        <Main t1='推广'  t2='我的广告发布任务'>            
            <Table 
                columns={columns} 
                dataSource={list} 
                pagination={{showSizeChanger:true,defaultPageSize:'50',showTotal:(total) => `共${total}条`}} 
            />
        </Main>
    )
}

export default PublishTask